import React, {ReactElement} from 'react';
import successLogo from '@assets/images/medops/success.svg';
const ThanksLogo = (props: any): ReactElement => {
  return <img src={successLogo} {...props} />;
};
export default ThanksLogo;
